import usePrivateAxios from "@/common/api/usePrivateAxios"
import { CompanyData, CompanyResponse } from "@/features/companies/types/companies.type"
import { UseQueryResult, useQuery } from "@tanstack/react-query"

type UseCompanyProps = {
  id: string
}

type UseCompanyType = ({}: UseCompanyProps) => UseQueryResult<CompanyData, unknown>

const useCompany: UseCompanyType = ({ id }) => {
  const privateAxios = usePrivateAxios()

  return useQuery<CompanyResponse, unknown, CompanyData>({
    queryKey: ['company', id],
    queryFn: () => {
      return privateAxios.get(`/client/companies/${id}`)
    },
    select: (data) => data?.data?.data,
  })
}

export default useCompany
